export default "__VITE_ASSET__DkZ_sB4U__"